/**
 * Houdt bij of de gebruiker aan het scrollen is in de dag-flow: een vinger op
 * het scherm, of een scroll-event korter dan de drempel geleden (ook de
 * momentum-scroll na het loslaten vuurt scroll-events).
 *
 * BELANGRIJK: zolang de gebruiker scrollt mag de dag-flow niets boven het
 * beeld wijzigen en de scrollpositie niet zelf zetten. iOS Safari negeert of
 * overschrijft een scrollTop-wijziging tijdens een momentum-scroll, en een dag
 * die boven het beeld bijkomt of wegvalt (met scroll-compensatie) liet de
 * weergave dan een paar dagen verspringen (Stevens iPhone-test 2026-09-26).
 * Zie de specs "tijdens het scrollen (iOS-momentum)" van de venster-logica.
 */
export class HdTransitScrollActivity {
  private touching = false;
  private lastScrollMs = Number.NEGATIVE_INFINITY;

  constructor(private readonly idleMs: number) {}

  touchStart(): void {
    this.touching = true;
  }

  /** Loslaten: de momentum-scroll kan nog volgen, dus de drempel start opnieuw. */
  touchEnd(nowMs: number): void {
    this.touching = false;
    this.lastScrollMs = nowMs;
  }

  userScroll(nowMs: number): void {
    this.lastScrollMs = nowMs;
  }

  /** Een sprong via de knoppen: de gebruiker scrollt op dat moment niet (meer). */
  reset(): void {
    this.touching = false;
    this.lastScrollMs = Number.NEGATIVE_INFINITY;
  }

  isIdle(nowMs: number): boolean {
    return !this.touching && nowMs - this.lastScrollMs >= this.idleMs;
  }

  /** Resterende tijd tot stil (0 = al stil; een vinger op het scherm = de volle drempel). */
  msUntilIdle(nowMs: number): number {
    if (this.touching) return this.idleMs;
    return Math.max(0, this.idleMs - (nowMs - this.lastScrollMs));
  }
}
